export const environment = {
  production: false,
  backendUrl: 'https://api.spitas.ch',
  useBackendMock: false,
  // Deployed dev environment: send cookies with requests
  sendCredentials: false,
};
